// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    // Grid Template
    'productGridItemHtml': '<div class="grid__item ' + bcSfFilterConfig.custom.grid_offset + ' ' + bcSfFilterConfig.custom.grid_width_small + ' ' + bcSfFilterConfig.custom.grid_width_medium + ' ' + bcSfFilterConfig.custom.grid_width_large + ' {{itemSaleClass}} {{itemTaggedClass}} product-grid-item product-grid-item-collection-new not-wood">' +
                                  '<a href="{{itemUrl}}" class="grid__image mask">' +
                                      `<div style='background-image: url("{{itemThumbUrl}}"); min-width: 100%; min-height: 100%; background-size: contain; background-position: center; background-repeat: no-repeat;' alt="{{itemTitle}}"></div>` +
                                      '{{itemLabels}}' +
                                      "{{itemWKBotton}}" +
                                  '</a>' +
                                  '<div class="figcaption ' + bcSfFilterConfig.custom.product_grid_style + ' ' + bcSfFilterConfig.custom.collection_text_alignment + '">' +
                                  '<div class="product-link">' +
                                  '<div class="h6 name_wrapper all-collections-names product-title" style="display:inline">' +
                                      '<span style="word-break: break-all">{{itemTitle}}</span>' +
                                      '<div class="wishl-add-wrapper custom" data-product-id="{{productId}}" data-product-handle="{{productHandle}}" data-variant-id="{{productVariantId}}" data-adder="atomic"></div>' +
                                  '</div>' +

                                  '<div class="product-info">' +
                                      '<div class="product-info-wrapper">' +
                                        '<div class="product-info__price">Price: {{itemPrice}} USD</div>'+
                                      '</div>'+
                                  '</div>'+

                                  "<div class='product-grid-item__bottom' style='border-top:1px solid #E1E1E0'>" + 
                                  "<a href='{{itemUrl}}' class='product-grid-item__bottom-link'>" +
                                  "<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M2.04539 11.5007C1.53879 10.5663 1.53879 9.43367 2.04538 8.49933C3.57935 5.67003 6.56636 3.75 9.9999 3.75C13.4335 3.75 16.4205 5.67003 17.9545 8.49933C18.4611 9.43367 18.4611 10.5663 17.9545 11.5007C16.4205 14.33 13.4335 16.25 9.9999 16.25C6.56636 16.25 3.57935 14.33 2.04539 11.5007Z' stroke='black'/><path d='M12.5105 9.96254C12.5105 11.3432 11.3913 12.4625 10.0105 12.4625C8.62984 12.4625 7.51053 11.3432 7.51053 9.96254C7.51053 8.58179 8.62984 7.46252 10.0105 7.46252C11.3913 7.46252 12.5105 8.58179 12.5105 9.96254Z' stroke='black'/></svg>" +
                                  "<span>View Product</span>" +
                                  "</a>" +
                                  "</div>" +

                                  '</div>' +
                                  '</div>' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',
  
    // Sorting Template
    'sortingHtml': '<label class="uppercase">' + bcSfFilterConfig.label.sorting + '</label><select>{{sortingItems}}</select>'
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    var new_product = false;
    var published_date = new Date(data.published_at).getTime() / 1000;
    var now_date = new Date().getTime() / 1000;
    var age_in_days = (now_date - published_date) / 3600 / 12;
    if (age_in_days < bcSfFilterConfig.custom.tag_new_limit) {
        new_product = true;
    }

    var sellout_tag = false;
    if (soldOut && bcSfFilterConfig.custom.tag_sale) {
        sellout_tag = true;
    }

    var new_tag = false;
    if (new_product && bcSfFilterConfig.custom.tag_new) {
        new_tag = true;
    }

    var sale_tag = false;
    if (onSale && bcSfFilterConfig.custom.tag_sale) {
        sale_tag = true;
    }

    var tagged = false;
    if (sellout_tag || new_tag || sale_tag ) {
        tagged = true;
    }

    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add onSale class
    var onSaleClass = onSale ? 'on-sale' : '';
    itemHtml = itemHtml.replace(/{{itemSaleClass}}/g, onSaleClass);

    // Add Tagged class
    var taggedClass = tagged ? 'tagged' : '';
    itemHtml = itemHtml.replace(/{{itemTaggedClass}}/g, taggedClass);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
    
    // Add Labels
    var itemLabelsHtml = '';
    if (tagged) {
        if (sellout_tag) {
            itemLabelsHtml += '<div class="sticker sticker--sold">' + bcSfFilterConfig.label.sold_out + '</div>';
        } else if (sale_tag) {
            itemLabelsHtml += '<div class="sticker sticker--sale">' + bcSfFilterConfig.label.sale + '</div>';
        } else if (new_tag) {
            itemLabelsHtml += '<div class="sticker sticker--new">' + bcSfFilterConfig.label.new + '</div>';
        }
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Price
    var itemPriceHtml = '<span class="price">';
    if (priceVaries) {
        itemPriceHtml += bcSfFilterConfig.label.from_price + ' ';
    }
    itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
    if (soldOut) {
        itemPriceHtml += '<br /><em>' + bcSfFilterConfig.label.sold_out + '</em>';
    }
    if (onSale) {
        itemPriceHtml += '<span class="compare-at">' +
                            '<span class="money">' + this.formatMoney(data.compare_at_price_min) + '</span>' +
                        '</span>';
    }
    itemPriceHtml += '</span>';
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Review
    var itemReviewHtml = '<br /><span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
    itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

      // Add Wishlist King Button

  let wkButton = `
  <span onclick="event.preventDefault();" class="wish-list" aria-label="Add to wishlist">
  <div
  class="wk-wishlist-button wk-wishlist-button--checkbox"
  data-product-handle="${data.handle}"
  data-variant-id="${data.variants[0].id}"
  id="wk-wishlist-button--new"
>

  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M12 21
        L4.1 13.2
        C1.5 10.6 1.5 6.9 3.7 4.7
        C6 2.4 9.7 2.4 12 4.7
        C14.3 2.4 18 2.4 20.3 4.7
        C22.5 7 22.5 10.6 19.9 13.2
        L12 21Z"
      fill="#fff"
      stroke="#231F20"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</div></span>`;

itemHtml = itemHtml.replace(/{{itemWKBotton}}/g, wkButton);

    // Prefer display_title metafield over Shopify product.title (same as bc-sf-filter.js)
    var displayTitleMf = Array.isArray(data.metafields)
      ? data.metafields.find(function (metafield) {
          return metafield && metafield.key === 'display_title' && metafield.value;
        })
      : null;
    var itemDisplayTitle =
      displayTitleMf && displayTitleMf.value ? displayTitleMf.value : data.title;

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, itemDisplayTitle);
    itemHtml = itemHtml.replace(/{{itemSku}}/g, data.skus);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
    itemHtml = itemHtml.replace(/{{productId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{productHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{productVariantId}}/g, data.variants[0].id);

    return itemHtml;
};



// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data) {
    // Integrate Product Review
    !function(){var e=function(e){var t={exports:{}};return e.call(t.exports,t,t.exports),t.exports};e(function(){"use strict";window.innerShiv=function(){function e(e,t,r){return/^(?:area|br|col|embed|hr|img|input|link|meta|param)$/i.test(r)?e:t+"></"+r+">"}var t,r,a=document,i="abbr article aside audio canvas datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video".split(" ");return function(n,s){if(!t&&(t=a.createElement("div"),t.innerHTML="<nav></nav>",r=1!==t.childNodes.length)){for(var o=a.createDocumentFragment(),d=i.length;d--;)o.createElement(i[d]);o.appendChild(t)}if(n=n.replace(/^\s\s*/,"").replace(/\s\s*$/,"").replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"").replace(/(<([\w:]+)[^>]*?)\/>/g,e),t.innerHTML=(o=n.match(/^<(tbody|tr|td|col|colgroup|thead|tfoot)/i))?"<table>"+n+"</table>":n,o=o?t.getElementsByTagName(o[1])[0].parentNode:t,!1===s)return o.childNodes;for(var d=a.createDocumentFragment(),u=o.childNodes.length;u--;)d.appendChild(o.firstChild);return d}}()});(function(){window.SPR=function(){function e(){}return e.shop=Shopify.shop,e.host="//productreviews.shopifycdn.com",e.version="v4",e.api_url=e.host+"/proxy/"+e.version,e.badgeEls=[],e.reviewEls=[],e.elSettings={},e.$=void 0,e.extraAjaxParams={shop:e.shop},e.registerCallbacks=function(){return this.$(document).bind("spr:badge:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onBadgeLoad:void 0),this.$(document).bind("spr:product:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onProductLoad:void 0),this.$(document).bind("spr:reviews:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onReviewsLoad:void 0),this.$(document).bind("spr:form:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormLoad:void 0),this.$(document).bind("spr:form:success","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormSuccess:void 0),this.$(document).bind("spr:form:failure","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormFailure:void 0)},e.loadStylesheet=function(){var e,t;return t=document.createElement("link"),t.setAttribute("rel","stylesheet"),t.setAttribute("type","text/css"),t.setAttribute("href","https://productreviews.shopifycdn.com/assets/v4/spr-5a2d2fd286dca8042a3a5a76bc9032c64c52a2792a734307c76740d012641514.css"),t.setAttribute("media","screen"),e=document.getElementsByTagName("head")[0],e.appendChild(t)},e.initRatingHandler=function(){return e.$(document).on("mouseover mouseout","form a.spr-icon-star",function(t){var r,a,i;return r=t.currentTarget,i=e.$(r).attr("data-value"),a=e.$(r).parent(),"mouseover"===t.type?(a.find("a.spr-icon:lt("+i+")").addClass("spr-icon-star-hover"),a.find("a.spr-icon:gt("+(i-1)+")").removeClass("spr-icon-star-hover")):a.find("a.spr-icon").removeClass("spr-icon-star-hover")})},e.initDomEls=function(){return this.badgeEls=this.$(".shopify-product-reviews-badge[data-id]"),this.reviewEls=this.$("#shopify-product-reviews[data-id]"),this.$.each(this.reviewEls,function(e){return function(t,r){var a;return a=e.$(r).attr("data-id"),e.elSettings[a]={},e.elSettings[a].reviews_el="#"+(e.$(r).attr("data-reviews-prefix")?e.$(r).attr("data-reviews-prefix"):"reviews_"),e.elSettings[a].form_el="#"+(e.$(r).attr("data-form-prefix")?e.$(r).attr("data-form-prefix"):"form_")}}(this))},e.loadProducts=function(){return this.$.each(this.reviewEls,function(e){return function(t,r){var a,i;if(a=e.$(r).attr("data-id"),"false"!==e.$(r).attr("data-autoload"))return i=e.$.extend({product_id:a,version:e.version},e.extraAjaxParams),e.$.get(e.api_url+"/reviews/product",i,e.productCallback,"jsonp")}}(this))},e.loadBadges=function(){var e,t,r,a,i;if(r=this.$.map(this.badgeEls,function(e){return function(t){return e.$(t).attr("data-id")}}(this)),r.length>0){for(t=7,i=[];(e=r.splice(0,t)).length>0;)a=this.$.extend(this.extraAjaxParams,{product_ids:e}),i.push(this.$.get(this.api_url+"/reviews/badges",a,this.badgesCallback,"jsonp"));return i}},e.pageReviews=function(e){var t,r,a;return a=this.$(e).data("product-id"),r=this.$(e).data("page"),t=this.$.extend({page:r,product_id:a},this.extraAjaxParams),this.$.get(this.api_url+"/reviews",t,this.paginateCallback,"jsonp"),!1},e.submitForm=function(e){var t;return t=this.$(e).serializeObject(),t=this.$.extend(t,this.extraAjaxParams),t=this.$.param(t),t=t.replace(/%0D%0A/g,"%0A"),this.$.ajax({url:this.api_url+"/reviews/create",type:"GET",dataType:"jsonp",data:t,success:this.formCallback,beforeSend:function(e){return function(){return e.$(".spr-button-primary").attr("disabled","disabled")}}(this),complete:function(e){return function(){return e.$(".spr-button-primary").removeAttr("disabled")}}(this)}),!1},e.reportReview=function(e){var t;return confirm("Are you sure you want to report this review as inappropriate?")&&(t=this.$.extend({id:e},this.extraAjaxParams),this.$.get(this.api_url+"/reviews/report",t,this.reportCallback,"jsonp")),!1},e.toggleReviews=function(e){var t;return t=this.$("#shopify-product-reviews[data-id='"+e+"']"),t.find(".spr-reviews").toggle()},e.toggleForm=function(e){var t;return t=this.$("#shopify-product-reviews[data-id='"+e+"']"),t.find(".spr-form").toggle()},e.setRating=function(e){var t,r,a;return t=this.$(e).parents("form"),a=this.$(e).attr("data-value"),r=this.$(e).parent(),t.find("input[name='review[rating]']").val(a),this.setStarRating(a,r)},e.setStarRating=function(e,t){return t.find("a:lt("+e+")").removeClass("spr-icon-star-empty spr-icon-star-hover"),t.find("a:gt("+(e-1)+")").removeClass("spr-icon-star-hover").addClass("spr-icon-star-empty")},e.badgesCallback=function(t){var r;return r=t.badges,e.$.map(e.badgeEls,function(t){var a;if(a=e.$(t).attr("data-id"),r[a]!==undefined)return e.$(t).replaceWith(r[a]),e.triggerEvent("spr:badge:loaded",{id:a})})},e.productCallback=function(t){var r;return r=t.remote_id.toString(),e.renderProduct(r,t.product),e.renderForm(r,t.form),e.renderReviews(r,t.reviews)},e.renderProduct=function(e,t){return this.$.map(this.reviewEls,function(r){return function(a){if(e===r.$(a).attr("data-id"))return r.$(a).html(innerShiv(t,!1)),r.triggerEvent("spr:product:loaded",{id:e})}}(this))},e.renderForm=function(e,t){var r;return r=this.$(this.elSettings[e].form_el+e),r.html(t),this.triggerEvent("spr:form:loaded",{id:e})},e.renderReviews=function(t,r){var a;return a=e.$(e.elSettings[t].reviews_el+t),a.html(r),e.triggerEvent("spr:reviews:loaded",{id:t})},e.formCallback=function(t){var r,a,i,n;return n=t.status,i=t.remote_id,a=t.form,r=e.$(e.elSettings[i].form_el+i),r.html(a),"failure"===n&&e.initStarRating(r),"success"===n&&e.$("#shopify-product-reviews[data-id='"+i+"'] .spr-summary-actions-newreview").hide(),e.triggerEvent("spr:form:"+n,{id:i})},e.initStarRating=function(e){var t,r,a;if((a=e.find("input[name='review[rating]']"))&&a.val())return r=a.val(),t=e.find(".spr-starrating"),this.setStarRating(r,t)},e.paginateCallback=function(t){var r,a;return a=t.remote_id.toString(),r=t.reviews,e.renderReviews(a,r)},e.reportCallback=function(t){var r;return r="#report_"+t.id,e.$(r).replaceWith("<span class='spr-review-reportreview'>"+e.$(r).attr("data-msg")+"</span>")},e.loadjQuery=function(t){return e.loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js",function(){return e.$=jQuery.noConflict(!0),t()})},e.loadScript=function(e,t){var r;return r=document.createElement("script"),r.type="text/javascript",r.readyState?r.onreadystatechange=function(){if("loaded"===r.readyState||"complete"===r.readyState)return r.onreadystatechange=null,t()}:r.onload=function(){return t()},r.src=e,document.getElementsByTagName("head")[0].appendChild(r)},e.loadjQueryExtentions=function(e){return e.fn.serializeObject=function(){var t,r;return t={},r=this.serializeArray(),e.each(r,function(){return t[this.name]?(t[this.name].push||(t[this.name]=[t[this.name]]),t[this.name].push(this.value||"")):t[this.name]=this.value||""}),t}},e.triggerEvent=function(e,t){return this.$(document).trigger(e,t)},e}(),function(){SPR.loadStylesheet(),SPR.loadjQuery(function(){return SPR.$.ajaxSetup({cache:!1}),SPR.loadjQueryExtentions(SPR.$),SPR.$(document).ready(function(){return SPR.registerCallbacks(),SPR.initRatingHandler(),SPR.initDomEls(),SPR.loadProducts(),SPR.loadBadges()})})}()}).call(this)}("undefined"!=typeof global?global:"undefined"!=typeof window&&window);
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data) {
    window.WishlApp.placeAdders();

    const changeHeight = () => {
        var maxHeight = 0;
        $(".product-link").each(function(){
            if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
        });

        $(".product-link").height(maxHeight);
    }

    changeHeight();

    if(typeof window.reinitializeCompare() === 'function' ) {
        window.reinitializeCompare();
    }
};


/************** Build Advanced Slider **************/
// Filter Type  : Options which their values are number
// Display Type : Range
// BCSfFilter.prototype.buildFilterOptionAdvancedRange = function(data, filterTreeId) {
//     var fOType = data.filterType, fODisplayType = data.displayType, fOSelectType = data.selectType, fOId = data.filterOptionId, fOLabel = data.label, fOValues = data.values;

//     var _this = this;
//     var itemValue = '';
//     var values = [];
//     var beforeValue = '', afterValue = '';

//     var sliderStep = 0.1;
//     var roundNumber = false;
//     var rangeDecimals = 1;
//     var floatRegex = /[+-]?\d+(\.\d+)?/g;

//     if (data.values.length > 0) {
//         // Extract the number from option values into an array
//         // Sort this array by order
//         for (var k in data['values']) {
//             var value = data['values'][k]['key'].match(floatRegex)[0];
//             if (roundNumber == true) value = Math.floor(value);
//             values.push(parseFloat(value));
//         }
//         values.sort(function(a,b) { return a - b;});

//         if (values.length > 1) {
//             // Get values before and after the number that is used for range
//             // When requesting API, re-append "before value" and "after value" to the number
//             var firstValue = data['values'][0]['key'].match(floatRegex)[0];
//             var tempElements = data['values'][0]['key'].split(firstValue);
//             if (tempElements.length == 2) {
//                 beforeValue = tempElements[0];
//                 afterValue = tempElements[1];
//             }

//             // Get Selector
//             var filterOptionRangeClass = this.class.filterOptionRange; // bc-sf-filter-option-range
//             var sliderId = filterOptionRangeClass + '-slider-' + fOId + filterTreeId; // bc-sf-filter-option-range-slider-pf_p_opt_size
//             var amountId = filterOptionRangeClass + '-amount-' + fOId + filterTreeId; // bc-sf-filter-option-amount-slider-pf_opt_size

//             var min = values[0],
//                 max = values[values.length - 1],
//                 currentMin = values[0],
//                 currentMax = values[values.length - 1];
//             // Get filter option range when it is selected
//             if (this.queryParams.hasOwnProperty(fOId)) {
//                 var selectedArr = this.queryParams[fOId];
//                 if (selectedArr && selectedArr.length > 1) {
//                     currentMin = selectedArr[0].match(floatRegex)[0];
//                     currentMax = selectedArr[selectedArr.length - 1].match(floatRegex)[0];
//                 } else if (selectedArr.length == 1) {
//                     currentMin = currentMax = selectedArr[0].match(floatRegex)[0];
//                 }
//                 itemValue = selectedArr.join(',');
//             }

//             // Build Range data
//             var range = {};
//             for (var k in values) {
//                 if (k == 0) {
//                     range['min'] = values[k];
//                 } else if (k == values.length - 1) {
//                     range['max'] = values[k];
//                 } else {
//                     var percent = 100 - ((values[values.length - 1] - values[k]) / (values[values.length - 1] - values[0]) * 100);
//                     range[percent + '%'] = values[k];
//                 }
//             }

//             // Get Template and Build data
//             var itemHtml = this.getTemplate('filterOptionAdvancedRange');
//             itemHtml = itemHtml.replace(/{{itemLabel}}/g, fOLabel).replace(/{{itemParentId}}/g, fOId).replace(/{{itemValue}}/g, itemValue).replace(/{{itemParentLabel}}/g, fOLabel);
//             itemHtml = itemHtml.replace(/{{rangeAmountId}}/g, amountId).replace(/{{rangeSliderId}}/g, sliderId);

//             // Add hidden value to store Min and Max value of range
//             var itemElement = jQ(itemHtml);
//             if (currentMin !== min || currentMax !== max) {
//                 itemElement.append('<input type="hidden" class="' + filterOptionRangeClass + '-' + fOId + '-check" value="1" />');
//             } else {
//                 itemElement.append('<input type="hidden" class="' + filterOptionRangeClass + '-' + fOId + '-check" />');
//             }
//             this.buildFilterOption(jQ(itemElement)[0].outerHTML, data, filterTreeId);

//             // Build Slider
//             var slider = document.getElementById(sliderId);
//             noUiSlider.create(slider, {
//                 start: [ currentMin, currentMax ],
//                 connect: true, // Display a colored bar between the handles
//                 behaviour: 'tap', // Move handle on tap, bar is draggable
//                 animate: true,
//                 snap: true,
//                 animationDuration: 300,
//                 step: sliderStep,
//                 range: range,
//                 format: wNumb({
//                    decimals: rangeDecimals
//                 })
//             });

//             // Build Slider event
//             slider.noUiSlider.on('update', function(values, handle) {
//                 jQ('#bc-sf-filter-' + fOId + '-lower').html(values[0]);
//                 jQ('#bc-sf-filter-' + fOId + '-upper').html(values[1]);
//             });
//             slider.noUiSlider.on('set', function(result, handle) {
//                 // If selected value are same with initial values, remove 'page' params and clear button on this filter option
//                 if (result[0] == min && result[1] == max) {
//                     jQ('.' + _this.class.filterOptionRange + '-' + fOId + '-check').val('0');
//                     jQ('#' + sliderId).attr('data-value', '');
//                 } else {
//                     var dataValue = '';
//                     for (var i in values) {
//                         if (values[i] >= result[0] && values[i] <= result[1]) {
//                             dataValue += beforeValue + encodeURIParamValue(values[i]) + afterValue + ',';
//                         }
//                     }
//                     dataValue = dataValue.slice(0, -1);
//                     jQ('#' + sliderId).attr('data-value', dataValue);
//                 }
//                 // Fire event to rebuild data and navigate
//                 var ev = typeof event !== 'undefined' ? event : new Event('build'); // Fix for Firefox
//                 onInteractWithFilterOptionValue(ev, jQ(this.target), fOType, 'range', fOSelectType);
//             });
//         }
//     }
// };

// // Build url for advanced filter options
// BCSfFilter.prototype.buildFilterOptionCustomLink = function(paramType, paramValue, filterType, displayType, selectType, keepValuesStatic) {
//     var link = '';
//     if (displayType == 'range' && filterType != 'price') {
//         link = window.location.href;
//         if (this.queryParams.hasOwnProperty(paramType)) {
//             var oldParams = this.queryParams[paramType];
//             for (var k in oldParams) {
//                 link = link.replace('&' + paramType + '=' + encodeURIParamValue(oldParams[k]), '');
//             }
//         }
//         var newParam = '';
//         if (paramValue != '') {
//             var valueArr = paramValue.split(',');
//             for (var k in valueArr) {
//                 newParam += '&' + paramType + '=' + encodeURIParamValue(valueArr[k]);
//             }
//         }
//         if (newParam != '') {
//             link = (window.location.search.length === 0 ? link + '?_=' + this.prefix : link) + newParam;
//         }
//     }
//     return link;
// }

// BCSfFilter.prototype.buildFilterSelectionData = function() {
//     var _this = this;
//     var selectionContent = '';

//     // Loop in all filter option block and find element selected
//     jQ(this.selector.filterTree + ' .' + this.class.filterOption).each(function() {
//         var type = jQ(this).data('type');
//         var id = jQ(this).data('id');
//         var title = jQ(this).data('title').trim();

//         // If filter option is list
//         if (jQ(this).find('a.selected').length > 0) {
//             jQ(this).find('a.selected').each(function() {
//                 if (type != 'collection') {
//                     var value = decodeURIComponent(jQ(this).attr('data-value'));
//                     var clearLink = _this.buildClearFilterOptionLink(id, title, value);
//                     var label = value;
//                     if (type == 'price') {
//                         label = _this.getPriceLabel(label);
//                     } else if (type == 'percent_sale') {
//                         label = _this.getPercentSaleLabel(label);
//                     } else if ((type == 'tag' || type == 'stock') && jQ(this).html() != '') {
//                         label = jQ(this).children().html();
//                     } else if (type == 'review_ratings') {
//                         label = jQ(this).html();
//                     }
//                     selectionContent += _this.buildFilterSelectionItem(_this.getTemplate('filterRefineItem'), title, label, clearLink);
//                 }
//             });
//         }
//         // If filter option is range
//         else if (jQ(this).find('.' + _this.class.filterOptionRange + '-check').val() == 1) {
//             var value = jQ(this).find('.' + _this.class.filterOptionRange + '-slider').attr('data-value');
//             var elements = value.split(':');
//             var label = elements[0] + ' - ' + elements[1];
//             if (type == 'price') {
//                 label = _this.formatMoney(elements[0] * 100) + ' - ' + _this.formatMoney(elements[1] * 100);
//             }
//             var clearLink = _this.buildClearFilterOptionLink(id, title, value);
//             selectionContent += _this.buildFilterSelectionItem(_this.getTemplate('filterRefineItem'), title, label, clearLink);
//         } else if (jQ(this).find('.' + _this.class.filterOptionRange + '-' + id + '-check').val() == 1) {
//             var value = jQ(this).find('.' + _this.class.filterOptionRange + '-slider').attr('data-value').split(',');
//             var minValue = jQ(this).find('.bc-sf-filter-range-value-lower').text();
//             var maxValue = jQ(this).find('.bc-sf-filter-range-value-upper').text();
//             var label = minValue + ' - ' + maxValue;

//             var clearLink = _this.buildClearFilterOptionLink(id, title, value);
//             selectionContent += _this.buildFilterSelectionItem(_this.getTemplate('filterRefineItem'), title, label, clearLink);
//         }
//     });
//     return selectionContent;
// };

// BCSfFilter.prototype.buildFilterSelectionItem = function(template, title, label, clearLink) {
//   template = template.replace(/{{itemType}}/g, title);
//   template = template.replace(/{{itemLabel}}/g, label);
//   console.log(title,clearLink);
//   template = template.replace(/{{itemLink}}/g, clearLink);
//   return template;
// }


function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};



